export default {
    createMode: {
        ufNameInput: '/globaladmin/service-providers/create/input/name',
        ufOrganizationIdInput:
            '/globaladmin/service-providers/create/input/organizationId',
        ufApiKeyInput: '/globaladmin/service-providers/create/input/apiKey',
        ufKeyExpiryInput:
            '/globaladmin/service-providers/create/input/keyExpiry',
        ufBackBtn: '/globaladmin/service-providers/create/button/back',
        ufCreateBtn: '/globaladmin/service-providers/create/button/create',
        ufEditBtn: '/globaladmin/service-providers/edit/button/save',
    },
    ufAddServiceProviderBtn: '/globaladmin/service-providers/table/button/add',
};
